import { Route, Routes } from "react-router-dom";

import React from "react";
import AnnouncementsPage from "../bulletins/AnnouncementsPage";
import SegmentsPage from "../bulletins/SegmentsPage";
import SuperuserDashboard from "./SuperuserDashboard";
import { WondeSync } from "./WondeSync";
import { SchoolsDashboard } from "./Schools";
import { SchoolView } from "./SchoolView";
import WondeSyncView from "./WondeSyncView";
import ImpersonationView from "./Impersonation";
import SuperuserRagManagement from "./SuperuserRagManagement";
import ApiAccessPage from "./ApiAccessPage";
import { SchoolGroupsDashboard } from "./SchoolGroups";
import SchoolGroupView from "./SchoolGroupView";
import UserView from "./UserView";
import OnboardingWorkflowPage from "./OnboardingWorkflowPage";
import OnboardingWorkflowsPage from "./OnboardingWorkflowsPage";
import OutreachEnrichmentPage from "./OutreachEnrichmentPage";
import MarketingPage from "./MarketingPage";
import OutreachPage from "./OutreachPage";
import OutreachContactsPage from "./OutreachContactsPage";

export const SuperuserRoutes = () => {
  return (
    <Routes>
      <Route path="marketing/announcements" element={<AnnouncementsPage />} />
      <Route
        path="marketing/announcements/:announcementId"
        element={<AnnouncementsPage />}
      />
      <Route path="marketing/segments" element={<SegmentsPage />} />
      <Route path="marketing/segments/:segmentId" element={<SegmentsPage />} />
      <Route path="home" element={<SuperuserDashboard />} />
      <Route path="users" element={<ImpersonationView />} />
      <Route path="wonde" element={<WondeSync />} />
      <Route path="schools" element={<SchoolsDashboard superuserView />} />
      <Route path="school_groups" element={<SchoolGroupsDashboard />} />
      <Route path="schools/:id" element={<SchoolView />} />
      <Route path="users/:id" element={<UserView />} />
      <Route path="school_groups/:id" element={<SchoolGroupView />} />
      <Route
        path="schools/:schoolId/sync/:syncId"
        element={<WondeSyncView />}
      />
      <Route path="rag" element={<SuperuserRagManagement />} />
      <Route path="api-access" element={<ApiAccessPage />} />
      <Route path="marketing" element={<MarketingPage />} />
      <Route path="marketing/workflows" element={<OnboardingWorkflowsPage />} />
      <Route path="marketing/outreach" element={<OutreachPage />} />
      <Route
        path="marketing/outreach/contacts"
        element={<OutreachContactsPage />}
      />
      <Route
        path="marketing/outreach/enrichment"
        element={<OutreachEnrichmentPage />}
      />
      <Route
        path="marketing/workflows/:workflowId"
        element={<OnboardingWorkflowPage />}
      />
    </Routes>
  );
};
